import React from 'react'
import { Button } from '@mui/material'
import { showIntercom, trackAnalyticEvent, ANALYTICS_LOCATIONS } from '../../utils'
import { ContactUsCard, ContactUsText } from './contact-us-info.styles'

export const ContactUsInfo = () => {
	return (
		<ContactUsCard>
			<ContactUsText>Don&apos;t see the integration you&apos;re looking for?</ContactUsText>
			<Button
				onClick={() => {
					showIntercom()
					trackAnalyticEvent(
						ANALYTICS_LOCATIONS.AVAILABLE_INTEGRATIONS,
						'click',
						'Contact Us',
					)
				}}
				variant={'contained'}>
					Contact us
			</Button>
		</ContactUsCard>
	)
}
